<template>
  <i
    class="tm-visual-scenes"
    :class="{ selected: isSelected, hovered: isHovered }"
  >
    <div
      v-for="scene in relevantScenes"
      :key="scene.guid"
      class="scene"
      :style="getSceneStyle(scene)"
    />
  </i>
</template>

<script>
import fg from '#/libs/FrameGrid';
export default {
  name: 'tm-visual-scenes',
  props: {
    track: { type: Object, required: true },
    scenes: { type: Array, required: false, default: () => [] },
    rectangle: { type: Object, required: true },
    isSelected: { type: Boolean, required: true },
    isHovered: { type: Boolean, required: true },
  },

  computed: {
    span() {
      return {
        startTime: fg.trunc(
          this.rectangle.startTime -
            this.track?.data?.displayStartTime +
            this.track?.data?.startTime
        ),
        endTime: fg.trunc(
          this.rectangle.endTime -
            this.track?.data?.displayStartTime +
            this.track?.data?.startTime
        ),
      };
    },
    relevantScenes() {
      const relevantScenes = this.scenes.filter((scene) => {
        const startTime = fg.trunc(scene.startTime);
        // console.log(this.span.startTime, startTime);
        return (
          startTime > this.span.startTime + fg.SPF * 3 &&
          startTime < this.span.endTime
        );
      });
      return relevantScenes;
    },

    totalDuration() {
      return fg.trunc(this.rectangle.endTime - this.rectangle.startTime);
    },
  },

  methods: {
    getSceneStyle(scene) {
      const left = app.sfp(
        ((scene.startTime -
          fg.SPF * 2 -
          this.track?.data?.startTime -
          this.rectangle.startTime +
          this.track?.data?.displayStartTime) /
          this.totalDuration) *
          this.rectangle.width,
        10
      );
      return {
        left: `${left}px`,
      };
    },
  },
};
</script>

<style lang="scss">
.tm-visual-span > .tm-visual-scenes {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 2;

  .scene {
    position: absolute;
    left: 0;
    height: 100%;
    width: 0;
    border-left: 3px dashed #f5a623; /* adjust color if needed */
    box-sizing: border-box;
    /* Optionally add a little opacity for a softer look */
    opacity: 0.9;
    transform: translateX(-50%);
  }
  // &.selected {
  //   .scene {
  //     border-left: 2px solid #f5a623;
  //   }
  // }
  &.hovered {
    .scene {
      opacity: 0.5;
    }
  }
}
</style>
